import tailwindConfig from '#tailwind-config'
import type { Theme } from '@/models/tailwind'

export default defineNuxtPlugin(() => {
  return {
    provide: { theme: tailwindConfig.theme as Theme },
  }
})
